<template>
	<div>
		<app-app-header v-model="indexStore.isHeaderVisible"
						:title="posting.title"
						:breadcrumbs="[{text: activeTypePage.indexTitle, to: activeTypePage.indexPath}, {text: postingOwner.display_name, to: activeTypePage.postingOwnerPath}]"
						:color="colorStyle"
						:image="{path: postingOwner.avatar_thumbnail}">
			<btn fab @click="indexStore.share({id: `job-${posting.id}`})">
				<icon :icon="icons.share"/>
			</btn>
		</app-app-header>
		<app-content>
			<page-content background xs-full sm-full has-app-bottom-bar>
				<lazy-cdn-background-image v-if="posting.background_image && $device.isDesktop" class="fixed w-screen h-screen top-0 left-0 right-0 bottom-0"
										   :src="posting.background_image"
										   :ratio="1920/1080" :width="1920" cover immediate/>

				<container xs-full sm-full class="stretch-layout">
					<job-posting-page :posting="posting" :group="posting.club"/>
				</container>
			</page-content>
		</app-content>
	</div>
</template>

<script setup lang="ts">
import {useIndexStore} from "../../../../store";
import {shareIcon} from "@spoferan/nuxt-spoferan/icons";

const {$api, $image, $web} = useNuxtApp();
const {t} = useI18n();
const route = useRoute();
const config = useRuntimeConfig();
const indexStore = useIndexStore();

const icons = {
	share: shareIcon
}

const typePageConfigs = {
	events: {
		key: 'events',
		jobDetailApiPath: $api('events.job_postings.show', [route.params.model, route.params.posting]),
		jobDetailRelations: ['club', 'event', 'category', 'operations'],
		postingOwnerPath: $web('jobs.events.show', [route.params.model]),
		indexPath: $web('jobs.events.index'),
		indexTitle: `${t('label.job_portal')} ${t('conjunction.for')} ${t('label.events')}`
	},
	clubs: {
		key: 'clubs',
		jobDetailApiPath: $api('clubs.job_postings.show', [route.params.model, route.params.posting]),
		jobDetailRelations: ['club', 'category', 'operations'],
		postingOwnerPath: $web('jobs.clubs.show', [route.params.model]),
		indexPath: $web('jobs.clubs.index'),
		indexTitle: `${t('label.job_portal')} ${t('conjunction.for')} ${t('label.clubs')}`,
	},
	companies: {
		key: 'companies',
		jobDetailApiPath: $api('clubs.job_postings.show', [route.params.model, route.params.posting]),
		jobDetailRelations: ['club', 'category', 'operations'],
		postingOwnerPath: $web('jobs.companies.show', [route.params.model]),
		indexPath: $web('jobs.companies.index'),
		indexTitle: `${t('label.job_portal')} ${t('conjunction.for')} ${t('label.companies')}`,
	},
};
const activeTypePage = typePageConfigs[route.params.type];

const {data} = await useApiFetch(activeTypePage.jobDetailApiPath, {
	params: {
		relations: activeTypePage.jobDetailRelations,
		with_similar_jobs: true
	}
});

const posting = data;
const postingOwner = data.event ?? data.club;
const colorStyle = postingOwner.color ?? config.public.colors.jobs

useMeta({
	title: `${posting.title} - ${posting.club.display_name}`,
	description: posting.short_description,
	image: posting.image ? $image.format(posting.image) : undefined,
})

</script>

